import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete, { AutocompleteRenderInputParams, AutocompleteRenderOptionState } from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { HTMLAttributes, useState } from "react";
import "./index.scss";
import { IconArrowBottom } from "../../icons";

const icon = <CheckBoxOutlineBlankIcon fontSize="medium" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface CheckboxesTags {
  listOptions: any[]; // {id: string, name: string, checked: boolean }
  setState: (value: any) => void;
  label?: string;
  limit?: number;
  placeholder?: string;
  disabled?: boolean;
  add?: { name: string; label: string; value: number };
  setAdd?: any;
}

export default function CheckboxesTags({ listOptions, setState, label, limit, placeholder, disabled, add, setAdd }: CheckboxesTags) {
  const list = add?.name ? listOptions?.concat(...[{ name: add?.label, id: -1, checked: false }]) : listOptions;
  const [optionsState, setOptionsState] = useState(list || []);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = Number(event.target.id);

    const data = optionsState?.map((option: any) => {
      if (option.id === index) {
        return {
          ...option,
          checked: !option.checked,
        };
      }
      return option;
    });

    setOptionsState(data);
    setState(data);
  };

  const render = (params: AutocompleteRenderInputParams) => {
    params.InputProps.startAdornment = isLabelRender().join(" | ");
    return (
      <>
        {label && <label className="label-checkbox">{label}</label>}
        <TextField
          {...params}
          disabled={disabled}
          className={`${disabled ? "disable-checkbox" : ""}`}
          placeholder={!isLabelRender().length ? `${placeholder ? placeholder : label}` : ""}
        />
      </>
    );
  };

  function isLabelRender() {
    return optionsState
      .filter((option: any) => Boolean(option.checked))
      .map((option) => option.name)
      .slice(0, limit ? limit : 3);
  }

  return (
    <Autocomplete
      multiple
      id="checkboxes"
      clearIcon=""
      popupIcon={
        <div
          style={{
            width: "18px",
            position: "absolute",
            top: "-7px",
            right: "1px",
            color: "var(--text)",
          }}
        >
          {IconArrowBottom}
        </div>
      }
      options={optionsState}
      disabled={disabled}
      disableCloseOnSelect
      getOptionLabel={(option: any) => option?.name}
      renderOption={(props: HTMLAttributes<HTMLLIElement>, option: any, { selected }: AutocompleteRenderOptionState) => {
        selected = option?.checked;
        return (
          <li
            {...props}
            onClick={() => {
              if (option.id === -1) setAdd({ ...option, name: add?.name, label: add?.label });
            }}
            className={`li-checkbox ${option.id === -1 && "li-new-field bg-primary color-text-contrast"}`}
          >
            {option.id !== -1 && (
              <Checkbox
                icon={icon}
                id={option?.id}
                onChange={handleOnChange}
                checkedIcon={checkedIcon}
                checked={selected}
                className={`pointer ${option.id === -1 && "bg-secondary color-text-contrast"}}`}
                style={{ marginRight: 8 }}
              />
            )}
            <span className={`checkbox-label-class ${option.id === -1 ? "new-field" : "old-field"}`}>{option?.name}</span>
          </li>
        );
      }}
      renderInput={(params: AutocompleteRenderInputParams) => render(params)}
    />
  );
}
